import React from "react";

export const BackgroundLoaderWrapper = ({ children }: { children: React.ReactNode }) => {

    return (
        <div className='user-settings-background-loader__wrapper'>{children}</div>
    );
}